import { render, staticRenderFns } from "./modificationAdmin.vue?vue&type=template&id=d630be4a&scoped=true"
import script from "./modificationAdmin.vue?vue&type=script&lang=js"
export * from "./modificationAdmin.vue?vue&type=script&lang=js"
import style0 from "./modificationAdmin.vue?vue&type=style&index=0&id=d630be4a&prod&lang=css"
import style1 from "./modificationAdmin.vue?vue&type=style&index=1&id=d630be4a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d630be4a",
  null
  
)

export default component.exports